const { $ } = window;

/**
 * Validation du bloc de facturation du tunnel d'achat, rejouée côté client.
 *
 * Elle existe parce que le paiement est déclenché AVANT la soumission du formulaire
 * (Payplug exécute le paiement, puis soumet) : sans ce garde-fou, un SIRET mal saisi
 * n'est rejeté qu'une fois l'acheteur débité.
 *
 * Les règles sont le miroir de AddressForm::processAddressForm() et de
 * AddressForm::cleanSiret(). Le serveur reste l'autorité : en cas de doute,
 * cette validation laisse passer (fail-open) plutôt que d'empêcher un paiement.
 */

const REQUIRED_MESSAGE = 'Merci de remplir ce champ.';
const SIRET_MESSAGE = 'Merci de saisir un SIRET valide (14 chiffres).';

const ADDRESS_FIELDS = ['streets', 'city', 'zipcode', 'country'];
const COMPANY_FIELDS = ['company', 'siret'];

const ERROR_MARKER_CLASS = 'js-billing-error';

/**
 * Clé de Luhn, identique à AddressForm::hasValidLuhnKey().
 */
function hasValidLuhnKey(digits) {
    let sum = 0;
    for (let position = 0; position < digits.length; position += 1) {
        let digit = parseInt(digits.charAt(digits.length - position - 1), 10);
        if (position % 2 === 1) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
    }
    return sum % 10 === 0;
}

/**
 * 14 chiffres, la clé du SIRET et celle du SIREN qu'il contient.
 */
function isValidSiret(value) {
    const siret = String(value).replace(/ /g, '');
    return /^\d{14}$/.test(siret)
        && hasValidLuhnKey(siret)
        && hasValidLuhnKey(siret.substring(0, 9));
}

/**
 * Les champs sont rendus par un formulaire imbriqué : leur préfixe dépend du
 * formulaire porteur. On les retrouve par le suffixe de leur name.
 */
function findField($form, fieldName) {
    return $form.find(`[name$="[${fieldName}]"]`).first();
}

function clearErrors($form) {
    $form.find(`.${ERROR_MARKER_CLASS}`).remove();
    $form.find('.c-form-item--error').removeClass('c-form-item--error');
}

function showError($field, message) {
    const $item = $field.closest('.c-form-item');
    $item.addClass('c-form-item--error');
    $item.find('.c-form-field').first().append(
        `<div class="the_popover the_popover_error ${ERROR_MARKER_CLASS}">`
        + '<div class="the_popover_icon"><i class="fa fa-times"></i></div>'
        + `<div class="text">${message}</div>`
        + '</div>',
    );
}

function validateBillingForm() {
    try {
        const $form = $('#payment-form');
        const $checkAddress = $('#check_address');

        // Pas de facture demandée : rien n'est réclamé, comme côté serveur.
        if (!$form.length || !$checkAddress.length || !$checkAddress.is(':checked')) {
            return true;
        }

        clearErrors($form);

        const wantsCompany = $('#check_company').is(':checked');
        const fields = wantsCompany ? ADDRESS_FIELDS.concat(COMPANY_FIELDS) : ADDRESS_FIELDS;
        let $firstInvalid = null;

        fields.forEach((fieldName) => {
            const $field = findField($form, fieldName);
            if (!$field.length) {
                return;
            }

            const value = $.trim($field.val() || '');
            let message = null;

            if (value === '') {
                message = REQUIRED_MESSAGE;
            } else if (fieldName === 'siret' && !isValidSiret(value)) {
                message = SIRET_MESSAGE;
            }

            if (message) {
                showError($field, message);
                $firstInvalid = $firstInvalid || $field;
            }
        });

        if ($firstInvalid) {
            $firstInvalid.focus();
            return false;
        }

        return true;
    } catch (error) {
        // La facturation ne doit jamais empêcher un achat d'aboutir :
        // en cas d'imprévu, on laisse le serveur trancher.
        console.error('[BILLING] validation skipped', error);
        return true;
    }
}

window.YP = window.YP || {};
window.YP.validateBillingForm = validateBillingForm;
